import UserProfileMenu from './UserProfileMenu'

export default UserProfileMenu
